module.exports = __webpack_public_path__ + "img/i_right.e5f70966.svg";